import { AxiosError } from 'axios';

/** The code both transcript endpoints refuse an oversized file with. */
const FILE_TOO_LARGE_CODE = 'transcriptFileTooLarge';

/**
 * The assessment and the thematic meeting transcripts share this refusal code but not the limit that
 * triggers it (10 MB against 2 MB): the caller says its own number back, so the generic upload
 * failure never borrows the other journey's.
 */
export const isTranscriptFileTooLargeError = (error: unknown): boolean =>
    error instanceof AxiosError &&
    error.response?.status === 400 &&
    (error.response.data as { error?: string } | undefined)?.error === FILE_TOO_LARGE_CODE;
